import type { Ref } from 'vue';
import type { IGridDetailExposed } from '../Grid/Classes/IGridDetailExposed';

/**
 * Contains the current state of the listcomponent
 */
export class ListCompState {
    /**
     * If the list has changed
     *
     * TODO: This is probably superfluous now since we have the `hasModifiedRowsInData` computed in the listcomp does the same thing
     */
    public IsChanged?: Ref<boolean>;

    /**
     * If there is at least one invalid row in the list
     */
    public HasInvalidRows?: Ref<boolean>;

    /**
     * The invalid fields in the list
     * this is a Map with the colId as key and the rows as value
     */
    public InvalidFields: Map<string, string[]> = new Map<string, string[]>();

    /**
     * The warning fields in the list
     * this is a Map with the colId as key and the rows as value
     */
    public WarningFields: Map<string, string[]> = new Map<string, string[]>();

    /**
     * The state of the detail grids
     */
    public DetailGrids: Array<IGridDetailExposed<any>> = [];

    /**
     * If the list is filtered on invalid rows
     */
    public IsFilteredInvalidRows: boolean = false;

    constructor() {
        if (this.IsChanged !== undefined) {
            this.IsChanged!.value = false;
        }
        if (this.HasInvalidRows !== undefined) {
            this.HasInvalidRows!.value = false;
        }
    }
}
